<template>
  <div>
    <div v-if="logs.length">
      <div class="my-2" v-for="log, index in logs" :key="index">
        <v-card>
          <v-card-title>
            <div>
              {{JSON.parse(log.log).name}}
            </div>
          </v-card-title>
          <v-card-subtitle>
            <v-row>
                <div>ID Device: {{log.id_device}}</div>
                <v-spacer></v-spacer>
                <div>ID Version: {{log.id_version}}</div>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-row >
              <v-col cols="12" sm="3" md="2" lg="2" :class="$vuetify.display.smAndUp ? 'text-right': ''">
                <div v-if="JSON.parse(log.log).foto">
                  <v-avatar size="100">
                    <v-img :src="'data:image/jpg;base64,'+JSON.parse(log.log).foto"></v-img>
                  </v-avatar>
                </div>
                <div v-else class="text-center">
                  <b>Sem Foto</b>
                </div>
              </v-col>
              <v-col cols="12" sm="9" md="10" lg="10">
                <div><b>Tipo de log: </b> <span :class="cores_tipo_log[log.tipo_log]">{{log.tipo_log}}</span> </div>
                <div><b>Validade: </b>{{JSON.parse(log.log).Validade}}</div>
                <div><b>E-mail: </b>{{JSON.parse(log.log).email}}</div>
                <div><b>Telefone: </b>{{JSON.parse(log.log).telefone}}</div>
                <div><b>CPF: </b>{{JSON.parse(log.log).cpf}}</div>
                <div><b>Motivo: </b>{{JSON.parse(log.log).comments}}</div>
                <div><b>Data Registro: </b>{{JSON.parse(log.log).timeOfRegistration_date}}</div>
                <div><b>Últ. Log Controlid: </b>{{JSON.parse(log.log).dataLastLog_date}}</div>
                <div><b>Status de Foto: </b>{{resultTest[JSON.parse(log.log).photoIdFaceState]}}</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
              <small class="text-grey">Log em: {{log.criado_em}}</small>
              <v-spacer></v-spacer>
              <small class="text-grey">Log por: {{log.created_by.username}} - {{log.created_by.first_name}}</small>
          </v-card-actions>
        </v-card>
      </div>
    </div>
    <div v-else>
      Nenhum log
    </div>
    <loading-gdb :dialog="StateIDSecureVisitantesLoading"/>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props:{
    idDevice:{
      required:true
    }
  },
  data:()=>({
    logs:[],
    resultTest:{
            0  : 'Status desconhecido',
            1  : 'Foto Enviada',
            2  : 'Rosto muito longe',
            3  : 'Rosto muito perto',
            4  : 'Face não centralizada',
            5  : 'Postura do rosto não centralizada',
            6  : 'Baixa Nitidez',
            7  : 'Rosto não detectado',
            8  : 'Face já existente',
            9  : 'Tamanho de imagem desconhecido',
            10 : 'Imagem Pequena',
            11 : 'Imagem muito grande',
            12 : 'Usuário não existe',
            13 : 'Muitas faces já estão cadastradas no dispositivo',
            14 : 'Rosto muito perto das bordas da imagem',
        },
        cores_tipo_log:{
          'lido': 'info--text',
          'alterado': 'text-error',
          'criado': 'text-success',
        }
  }),
  methods:{
    ...mapActions(['GetLogVisitante']),
    async loadLog(){
      let response = await this.GetLogVisitante(this.idDevice)
      try{
        response = response[0]
      }catch{
        //
      }
      // console.log(response)
      if (response.status == 200){
        this.logs = response.data.results
      }else{
        this.logs = []
        alert('Falha ao carregar logs')
      }
    }
  },
  computed:{
    ...mapGetters(['StateIDSecureVisitantesLoading'])
  },
  mounted(){
    if (this.$verify.pode_ver_logvisitante()){
      this.loadLog()
    }else{
      alert('Este usuário não tem permissão para visualização de logs')
    }
  }
}
</script>
<style scoped>
  .links{
    text-decoration: none;
  }
</style>